var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.399 5l-7.47 4.15V.85L9.399 5z",
    stroke: "currentcolor",
    strokeLinecap: "square"
  })));
}

export default SvgPlaySmall;